import { useDispatch, useSelector } from 'react-redux';

import { userInstrumentsSlice } from '!core/redux';
import { getError } from '!core/redux/userInstruments/userInstruments.selectors';
import { ButtonRefresh } from '»components/atoms/Buttons';
import { getActiveMenuItemSelector } from '»components/Menus';
import {
  TrlAccountInfo,
  TrlFeedbackModal,
  TrlSearchBar,
} from '»components/molecules';
import { useCurrentPage } from '»utils/customHooks';

import {
  AppBarLeftStyled,
  AppBarRightStyled,
  AppBarWrapperStyled,
} from '../../AppBar.styles';
import { TrlAccountInfoContainerStyled } from './AppBarPrivate.mobile.styles';

export const AppBarPrivateMobile = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const favError = useSelector(getError);

  const handleCloseFeedbackModal = () => {
    dispatch(userInstrumentsSlice.actions.resetError());
  };

  const isPrimaryMarket =
    activeMenuItem === 'TRADING:PRIMARY' ||
    activeMenuItem === 'TRADING:PRIMARY:PROOF' ||
    activeMenuItem === 'MARKET:PRIMARY';

  const { isProofPreviewPage } = useCurrentPage();

  return (
    <>
      {!isProofPreviewPage && activeMenuItem !== 'GENERIC:SETTINGS' && (
        <AppBarWrapperStyled isAuthenticated>
          <TrlFeedbackModal
            title={{ content: 'TRLT_UI-ERROR' }}
            descr={{ content: favError }}
            type="warning"
            open={favError !== ''}
            onClose={handleCloseFeedbackModal}
          />
          <AppBarLeftStyled isAuthenticated>
            {!isPrimaryMarket ? (
              <TrlSearchBar open={!isPrimaryMarket} />
            ) : (
              <div />
            )}
          </AppBarLeftStyled>
          <AppBarRightStyled isAuthenticated>
            <ButtonRefresh />
          </AppBarRightStyled>
        </AppBarWrapperStyled>
      )}
      {activeMenuItem !== 'GENERIC:SETTINGS:ACCOUNTS' &&
        activeMenuItem !== 'GENERIC:SETTINGS:PASSWORD' &&
        activeMenuItem !== 'GENERIC:SETTINGS:LANGUAGE' &&
        activeMenuItem !== 'GENERIC:SETTINGS:SUPPORT' &&
        activeMenuItem !== 'GENERIC:SETTINGS:EMAIL' &&
        activeMenuItem !== 'GENERIC:SETTINGS:QUESTIONNAIRE' &&
        activeMenuItem !== 'GENERIC:SETTINGS:CONTACT' &&
        activeMenuItem !== 'GENERIC:SETTINGS:OTPDELIVMETH' &&
        activeMenuItem !== 'TRADING:PRIMARY:PROOF' &&
        activeMenuItem !== 'TRADING:BOLSA:PROOF' &&
        activeMenuItem !== 'TRADING:BOLSA:DETAILS:PROOF' &&
        activeMenuItem !== 'TRADING:FUNDS:PROOF' &&
        activeMenuItem !== 'TRADING:FUNDS:DETAILS:PROOF' &&
        activeMenuItem !== 'MARKET:PRIMARY:PROOF' &&
        activeMenuItem !== 'MARKET:BOLSA:PROOF' &&
        activeMenuItem !== 'MARKET:BOLSA:DETAILS:PROOF' &&
        activeMenuItem !== 'MARKET:FUNDS:PROOF' &&
        activeMenuItem !== 'MARKET:FUNDS:DETAILS:PROOF' && (
          <TrlAccountInfoContainerStyled>
            <TrlAccountInfo />
          </TrlAccountInfoContainerStyled>
        )}
    </>
  );
};
